import {
  SET_VALUE,
  REMOVE_VALUE,
  ADD_VALUE,
  ADD_ENUM_OPTIONS,
  SET_FIELDS,
  SET_DISABLED,
  SET_REQUIRED,
  RESET_STATE
} from 'constants/actionTypes';
import update from 'immutability-helper';
import { getFieldValuesCopy } from 'helpers/fieldHelpers';

export const initialFieldState = {
  fields: {}, // [predicate]: field
  originalFields: {},
  enums: {}
};

// Reducer for Field edit state
export default function(state = initialFieldState, action) {
  switch (action.type) { 
  case ADD_ENUM_OPTIONS:
    return {
      ...state,
      enums: update(state.enums, { 
        $set: Object.assign(state.enums, action.enums)
      })
    };
    
  case RESET_STATE:
    return {
      ...initialFieldState
    };
  }

  if (action.modalOpen) {
    return state; // Ignore value actions if modal open!
  }

  switch (action.type) {
  case SET_VALUE:
    return {
      ...state,
      fields: update(state.fields,  {
        [action.predicate]: {
          values: {
            [action.index]: { $set: action.value },
          }
        }
      })
    };

  case ADD_VALUE:
    return {
      ...state,
      fields: update(state.fields, {
        [action.predicate]: {
          values: { $push: [action.value ? action.value : ''] }
        }
      })
    };

  case REMOVE_VALUE:
    return {
      ...state,
      fields: update(state.fields, {
        [action.predicate]: { 
          values: { $splice: [[action.index, 1]] }
        }
      })
    };

  case SET_FIELDS:
    return {
      ...state,
      fields: action.fields,
      originalValues: getFieldValuesCopy(action.fields)
    };

  case SET_DISABLED:
    return {
      ...state,
      fields: update(state.fields, {
        [action.predicate]: { 
          disabled: { $set: action.value }
        }
      })
    };

  case SET_REQUIRED:
    return {
      ...state,
      fields: update(state.fields, {
        [action.predicate]: {
          required: { $set: action.value }
        }
      })
    };
  }

  return state;
}